import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

// Reading-optimized markdown renderer (Literata prose on dark)
export const Markdown = ({ children, className }) => {
    return (
        <div
            className={cn(
                "font-reading text-[15px] md:text-[16px] leading-[1.78] text-t2",
                "[&_h1]:font-sans-display [&_h1]:text-t1 [&_h1]:text-xl [&_h1]:font-semibold [&_h1]:mt-5 [&_h1]:mb-2",
                "[&_h2]:font-sans-display [&_h2]:text-t1 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:mt-5 [&_h2]:mb-2",
                "[&_h3]:font-sans-display [&_h3]:text-t1 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:mt-4 [&_h3]:mb-1.5",
                "[&_p]:my-3 [&_strong]:text-t1 [&_strong]:font-semibold",
                "[&_ul]:my-3 [&_ul]:pl-5 [&_ul]:list-disc [&_li]:my-1.5 [&_li]:marker:text-[hsl(var(--primary))]",
                "[&_ol]:my-3 [&_ol]:pl-5 [&_ol]:list-decimal",
                "[&_blockquote]:border-l-2 [&_blockquote]:border-[hsl(var(--primary))] [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:text-t3",
                "[&_code]:font-mono-ui [&_code]:text-[13px] [&_code]:bg-surface-3 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded",
                "[&_a]:text-[hsl(var(--primary))] [&_a]:underline",
                "[&_table]:w-full [&_table]:my-3 [&_th]:text-left [&_th]:text-t1 [&_td]:border-t [&_td]:border-border [&_td]:py-1.5 [&_th]:py-1.5",
                className
            )}
        >
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{children || ""}</ReactMarkdown>
        </div>
    );
};
